import {
  Box,
  BoxProps,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { BookingItemTable } from '../../../../../../../../../components/BookingItemTable';
import { BookingScheduleItemTable } from '../../../../../../../../../components/BookingScheduleItemTable';
import { useBookingQueue } from '../../../../../../../../../hooks/bookingQueue';

export const BookingQueueDetailsTabs = (props: BoxProps): JSX.Element => {
  const { bookingQueue } = useBookingQueue();

  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return bookingQueue ? (
    <Box {...props}>
      <Tabs
        index={tabIndex}
        onChange={handleTabChanges}
        variant="enclosed-colored"
        isLazy
      >
        <TabList>
          <Tab>Opcionais da atividade</Tab>

          <Tab>Opcionais do evento</Tab>
        </TabList>

        <TabPanels mt="4">
          <TabPanel>
            <BookingItemTable bookingItems={bookingQueue.items} />
          </TabPanel>

          <TabPanel>
            <BookingScheduleItemTable
              scheduleItems={bookingQueue.scheduleItems}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  ) : (
    <></>
  ); // loading view
};
